// Utility functions for dashboard widgets

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveBadgeUrl = (badge) => {
  if (!badge) return null;
  if (badge.startsWith('http://') || badge.startsWith('https://')) return badge;
  return `${BACKEND_URL}${badge}`;
};

export const getVenueAbbrev = (venue) => (venue === 'home' ? 'H' : venue === 'away' ? 'A' : 'N');

// Get match result with color coding
export const getMatchResult = (match) => {
  // For cup matches, check ET and penalties for the actual winner
  if (match.is_cup) {
    // Check penalties first (takes precedence)
    if (match.our_score_pens != null && match.opponent_score_pens != null) {
      if (match.our_score_pens > match.opponent_score_pens) return { label: 'W', color: 'bg-emerald-500 text-white' };
      if (match.our_score_pens < match.opponent_score_pens) return { label: 'L', color: 'bg-red-500 text-white' };
    }
    // Check extra time
    if (match.our_score_et != null && match.opponent_score_et != null) {
      if (match.our_score_et > match.opponent_score_et) return { label: 'W', color: 'bg-emerald-500 text-white' };
      if (match.our_score_et < match.opponent_score_et) return { label: 'L', color: 'bg-red-500 text-white' };
    }
  }
  // Regular time result
  if (match.our_score > match.opponent_score) return { label: 'W', color: 'bg-emerald-500 text-white' };
  if (match.our_score < match.opponent_score) return { label: 'L', color: 'bg-red-500 text-white' };
  return { label: 'D', color: 'bg-amber-500 text-white' };
};

// Format date as "Sun, Mar 15"
export const formatDateShort = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00');
  const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = date.getDate();
  return `${weekday}, ${month} ${day}`;
};

// Default widget order
export const DEFAULT_WIDGET_ORDER = [
  'next-fixture-countdown',
  'upcoming-matches',
  'recent-results',
  'recent-form',
  'cup-progress',
  'upcoming-training',
  'top-scorers',
  'top-assisters',
  'form-of-the-week',
  'training-attendance',
  'record-summary',
  'quick-stats'
];

// Widget display names
export const WIDGET_NAMES = {
  'next-fixture-countdown': 'Next Match',
  'upcoming-matches': 'Fixtures',
  'recent-results': 'Recent Results',
  'recent-form': 'Recent Form',
  'cup-progress': 'Cup Progress',
  'upcoming-training': 'Training',
  'top-scorers': 'Top Scorers',
  'top-assisters': 'Top Assisters',
  'form-of-the-week': 'Form of the Week',
  'training-attendance': 'Training Attendance',
  'record-summary': 'Record Summary',
  'quick-stats': 'Quick Stats'
};

// Widget IDs that have been removed/merged — filtered out of user saved orders
export const DEPRECATED_WIDGET_IDS = ['top-performers'];

// Helper to merge saved widget order with any new widgets (and drop deprecated ones)
export const mergeWidgetOrder = (savedOrder, defaultOrder) => {
  const cleaned = (savedOrder || []).filter((id) => !DEPRECATED_WIDGET_IDS.includes(id));
  if (cleaned.length === 0) return defaultOrder;

  // Find widgets in default that aren't in saved order
  const newWidgets = defaultOrder.filter((widgetId) => !cleaned.includes(widgetId));

  // Add new widgets at the end
  return [...cleaned, ...newWidgets];
};
